/* Dudes Boutique — 4:5 card carousel.
   Native scroll-snap does the scrolling; this only wires the arrows and
   disables them at the ends. No dependency on Dawn's slider component. */
class DDCardCarousel extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('[data-dd-cards-track]');
    if (!this.track) return;
    this.prev = this.querySelector('[data-dd-cards-prev]');
    this.next = this.querySelector('[data-dd-cards-next]');

    this.prev && this.prev.addEventListener('click', () => this.scrollByPage(-1));
    this.next && this.next.addEventListener('click', () => this.scrollByPage(1));
    this.track.addEventListener('scroll', () => this.updateArrows(), { passive: true });

    // Two-way toggle (e.g. Men's / Women's). The active side is also set
    // server-side via data-active, so the right cards show before this runs.
    this.tabs = Array.from(this.querySelectorAll('[data-dd-cards-tab]'));
    this.tabs.forEach((tab) => {
      tab.addEventListener('click', () => this.setSide(tab.dataset.ddCardsTab));
    });
    window.addEventListener('resize', () => this.updateArrows());
    this.updateArrows();
  }

  scrollByPage(direction) {
    const item = this.track.querySelector('.dd-cards__item');
    if (!item) return;
    const step = item.getBoundingClientRect().width + this.gap();
    const perPage = Math.max(1, Math.floor(this.track.clientWidth / step));
    this.track.scrollBy({ left: direction * step * perPage, behavior: 'smooth' });
  }

  setSide(side) {
    if (this.getAttribute('data-active') === side) return;
    this.setAttribute('data-active', side);
    this.tabs.forEach((t) => t.setAttribute('aria-selected', String(t.dataset.ddCardsTab === side)));
    this.track.scrollLeft = 0;
    this.updateArrows();
  }

  gap() {
    return parseFloat(getComputedStyle(this.track).columnGap) || 0;
  }

  updateArrows() {
    if (!this.prev || !this.next) return;
    const max = this.track.scrollWidth - this.track.clientWidth;
    // 4 cards in 4 columns cannot scroll on desktop but can on mobile, so
    // this is decided from the rendered width rather than the card count.
    if (max <= 1) {
      this.setAttribute('data-no-overflow', '');
      return;
    }
    this.removeAttribute('data-no-overflow');
    this.prev.disabled = this.track.scrollLeft <= 1;
    this.next.disabled = this.track.scrollLeft >= max - 1;
  }
}

if (!customElements.get('dd-card-carousel')) {
  customElements.define('dd-card-carousel', DDCardCarousel);
}
